import { Component, Input, OnInit } from '@angular/core';
import { TranslateService }         from '@ngx-translate/core';
import { UIRouter }                 from '@uirouter/core';

import napaIcon from 'icons/napa.svg';

import { CodeTypeModel }            from '../core/models/code-type';
import { CompanyIntegrationsModel } from '../companies/models/company.integrations';
import { MessagesService }          from '../messages/messages.service';
import { ProlinkService }           from './prolink.service';
import { ProlinkSettingsModel }     from './typings/prolink.settings';
import { VendorModel }              from '../vendors/models/vendor';
import { VendorSearchService }      from '../vendors/vendor.search.service';

@Component({
  selector   : 'prolink-settings',
  template: require('./prolink.settings.component.html')
})
export class ProlinkSettingsComponent implements OnInit {
  @Input() companySettings: CompanyIntegrationsModel;
  @Input() settings       : ProlinkSettingsModel;

  confirmPassword : string;
  napaIcon        : string = napaIcon;
  priceOptions    : Array<CodeTypeModel> = [
    {
      code          : 'NOTHING',
      language_label: 'JS_SPACE.PROLINK.DONT_CHANGE_THE_PRICE'
    },
    {
      code          : 'DIFFERENT',
      language_label: 'JS_SPACE.PROLINK.PRICE_IS_DIFFERENT'
    },
    {
      code          : 'HIGHER',
      language_label: 'JS_SPACE.PROLINK.PRICE_HIGHER'
    },
    {
      code          : 'ALL',
      language_label: 'JS_SPACE.PROLINK.ALWAYS_USE_PROLINK_PRICE'
    }
  ];
  title           : string = this.prolinkService.title;
  vendor          : VendorModel;

  constructor (
    private messagesService    : MessagesService,
    private prolinkService     : ProlinkService,
    private router             : UIRouter,
    private translateService   : TranslateService,
    private vendorSearchService: VendorSearchService
  ) {}

  activate () : void {
    this.prolinkService.activate()
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.ACTIVATED', {
        name: this.title
      }), 'success');

      this.router.stateService.reload();
    })
    .catch(err => {
      this.messagesService.error(err);
    });
  }

  deactivate () : void {
    this.prolinkService.deactivate()
    .then(() => {
      this.router.stateService.reload();
    })
    .catch(err => {
      this.messagesService.error(err);
    });
  }

  getVendor () : void {
    this.vendorSearchService.get(this.settings.prolink_vendor_id)
    .then(( vendor : VendorModel ) => {
      this.vendor = vendor;
    })
    .catch(() => null);
  }

  handleVendorChange ( vendor : string | VendorModel ) : void {
    if (!vendor) {
      this.settings.prolink_vendor_id = '';

      if (this.settings.prolink_settings) {
        this.settings.prolink_settings.prolink_vendor_name = '';
      }
    }
  }

  hasPasswordChanged () : boolean {
    return !!this.settings.prolink_password;
  }

  newVendor () : void {
    this.vendorSearchService.quickAdd()
    .then(( vendor : VendorModel ) => {
      this.vendor = vendor;
      this.setVendor(vendor);
      this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.SUPPLIER_FOR_INTEGRATION', {
        name: this.title
      }), 'success');
    })
    .catch(() => null);
  }

  ngOnInit () : void {
    if (this.settings.prolink_vendor_id) {
      this.getVendor();
    }
  }

  save () : void {
    this.prolinkService.save(this.settings, this.companySettings)
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.SAVED.SETTINGS'), 'success');

      this.router.stateService.reload();
    })
    .catch(err => {
      this.messagesService.error(err);
    });
  }

  setVendor ( vendor : VendorModel ) : void {
    this.settings.prolink_vendor_id = vendor.id;

    if (!this.settings.prolink_settings) {
      this.settings.prolink_settings = {};
    }

    this.settings.prolink_settings.prolink_vendor_name = vendor.company_name;
  }
}
